/**
 * Analytics event constants and GTM mapping.
 * All GTM/GA4 event names use lowercase snake_case for seamless GA4 mapping.
 */

export const EVENTS = {
  PAGE_VIEW: 'PAGE_VIEW',
  TAP_PROCEED_TO_PAYMENT: 'TAP_PROCEED_TO_PAYMENT',
  TAP_ON_FIELD: 'TAP_ON_FIELD',
  FOUCUS_OUT_OF_FIELD: 'FOUCUS_OUT_OF_FIELD',
  CLICK: 'CLICK',

  // CKD Events - internal keys (mapped to snake_case for GTM/GA4)
  CKD_LKF_MainPageLanding: 'CKD_LKF_MainPageLanding',
  CKD_LKF_GetKidneyScore1: 'CKD_LKF_GetKidneyScore1',
  CKD_LKF_ScanFood1: 'CKD_LKF_ScanFood1',
  CKD_LKF_BookLabTest1: 'CKD_LKF_BookLabTest1',
  CKD_LKF_DownloadBook: 'CKD_LKF_DownloadBook',
  CKD_LKF_ScanFood2: 'CKD_LKF_ScanFood2',
  CKD_LKF_GetKidneyScore2: 'CKD_LKF_GetKidneyScore2',
  CKD_LKF_BookLabTest2: 'CKD_LKF_BookLabTest2',
  CKD_LKF_MobileNumberSubmit_StartPNDS: 'CKD_LKF_MobileNumberSubmit_StartPNDS',
  CKD_LKF_MobileNumberSubmit_StartSCORE:
    'CKD_LKF_MobileNumberSubmit_StartSCORE',
  CKD_LKF_MobileNumberSubmit_StartDIAGNOSTICS:
    'CKD_LKF_MobileNumberSubmit_StartDIAGNOSTICS',
  CKD_LKF_Score_FoodGrade: 'CKD_LKF_Score_FoodGrade',
  CKD_LKF_Food_Scan_Landing: 'CKD_LKF_Food_Scan_Landing',
  CKD_LKF_Book_Diagnostics_Landing: 'CKD_LKF_Book_Diagnostics_Landing',
  CKD_LKF_Kidney_Score_Questionnaire_Landing:
    'CKD_LKF_Kidney_Score_Questionnaire_Landing',
}

/**
 * GTM/GA4 event configuration.
 * Maps internal event keys to standardized snake_case event names
 * and structured payload metadata (page_type, section, user_action).
 */
export const GTM_EVENT_CONFIG = {
  [EVENTS.PAGE_VIEW]: {
    event: 'page_view',
    page_type: 'landing',
    section: 'main',
    user_action: 'view',
  },
  [EVENTS.CKD_LKF_MainPageLanding]: {
    event: 'ckd_mainpage_view',
    page_type: 'landing',
    section: 'main',
    user_action: 'view',
  },
  [EVENTS.CKD_LKF_GetKidneyScore1]: {
    event: 'ckd_quiz_click_top',
    page_type: 'landing',
    section: 'kidney_score',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_GetKidneyScore2]: {
    event: 'ckd_quiz_click_bottom',
    page_type: 'landing',
    section: 'kidney_score',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_ScanFood1]: {
    event: 'ckd_food_scan_click_top',
    page_type: 'landing',
    section: 'food_scan',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_ScanFood2]: {
    event: 'ckd_food_scan_click_bottom',
    page_type: 'landing',
    section: 'food_scan',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_BookLabTest1]: {
    event: 'ckd_book_diagnostics_click_top',
    page_type: 'landing',
    section: 'diagnostics',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_BookLabTest2]: {
    event: 'ckd_book_diagnostics_click_bottom',
    page_type: 'landing',
    section: 'diagnostics',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_DownloadBook]: {
    event: 'ckd_book_download_click',
    page_type: 'landing',
    section: 'download_book',
    user_action: 'click',
  },
  [EVENTS.CKD_LKF_MobileNumberSubmit_StartPNDS]: {
    event: 'ckd_mobile_submit_start_pnds',
    page_type: 'modal',
    section: 'login',
    user_action: 'submit',
  },
  [EVENTS.CKD_LKF_MobileNumberSubmit_StartSCORE]: {
    event: 'ckd_mobile_submit_start_score',
    page_type: 'score',
    section: 'kidney_score',
    user_action: 'complete',
  },
  [EVENTS.CKD_LKF_MobileNumberSubmit_StartDIAGNOSTICS]: {
    event: 'ckd_mobile_submit_start_diagnostics',
    page_type: 'modal',
    section: 'login',
    user_action: 'submit',
  },
  [EVENTS.CKD_LKF_Score_FoodGrade]: {
    event: 'ckd_quiz_complete',
    page_type: 'result',
    section: 'kidney_score',
    user_action: 'submit',
  },
  [EVENTS.CKD_LKF_Food_Scan_Landing]: {
    event: 'ckd_food_scan_landing',
    page_type: 'landing',
    section: 'food_scan',
    user_action: 'view',
  },
  [EVENTS.CKD_LKF_Book_Diagnostics_Landing]: {
    event: 'ckd_book_diagnostics_landing',
    page_type: 'landing',
    section: 'diagnostics',
    user_action: 'view',
  },
  [EVENTS.CKD_LKF_Kidney_Score_Questionnaire_Landing]: {
    event: 'ckd_quiz_landing',
    page_type: 'landing',
    section: 'kidney_score',
    user_action: 'view',
  },
}
